<template>
  <div class="full">
    <div class="nav-top flex justify-between  border-gray-300 border-b">
      <div class="">
        Graphics Demos
      </div>
      <div class="">
        Air Concepts x Lok Lok
      </div>
    </div>
    <div class="lg:flex">
      <div class="pattern-item">
        <router-link to="/edit/stars">
          <StarEffect :useControls="false"></StarEffect>
        </router-link>
      </div>
      <div class="pattern-item">
      </div>
      <div class="pattern-item">
      </div>
      <div class="pattern-item">
      </div>
    </div>
  </div>
</template>

<script>
import { O3DVue } from '../../Core/O3DVue.js'
export default {
  mixins: [
    O3DVue
  ]
}
</script>

<style lang="postcss">
</style>

